// extracted by mini-css-extract-plugin
module.exports = {"loader-row":"loader-row__10vwr","loader":"loader__3dtni"};